import { getComponentsStyles } from '../commons/components/styles';
import { getFont } from '../config/font';
import { FONT_FAMILY } from '../config/horizon/text';
import { getShadow } from '../config/shadow';
import { animations } from './animations/animations';
import { HORIZON_LIGHT_ALT_BASE_STYLES } from './baseStyles';
import { horizonLightAlt as FOUNDATIONS_STYLES } from './horizonLightAlt';
const SHADOWS = getShadow(FOUNDATIONS_STYLES);
const FONT_STYLES = getFont(FOUNDATIONS_STYLES);
const COMPONENTS_STYLES = {
    ...getComponentsStyles(FOUNDATIONS_STYLES, FONT_STYLES, animations, FONT_FAMILY, SHADOWS),
};
export const HORIZON_LIGHT_ALT_STYLES = {
    ...COMPONENTS_STYLES,
    ...HORIZON_LIGHT_ALT_BASE_STYLES,
};
//# sourceMappingURL=styles.js.map